import * as tslib_1 from "tslib";
import * as React from 'react';
import { NamePatcher, isValidProp, getModifiedProps } from "igniteui-react-core";
import { ReactRenderer } from "igniteui-react-core";
import { DataGridStylingDefaults } from './DataGridStylingDefaults';
import { GridColumnMoveOptions } from './GridColumnMoveOptions';
import { IgrGridColumnOptionsSimpleSectionBase } from "./igr-grid-column-options-simple-section-base";
var IgrGridColumnMoveOptions = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridColumnMoveOptions, _super);
    function IgrGridColumnMoveOptions(props) {
        var _this = _super.call(this, props) || this;
        _this._reactRenderer = null;
        if (_this._styling) {
            NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
        }
        _this._getMainRef = _this._getMainRef.bind(_this);
        if (document) {
            _this._mainDiv = document.createElement("div");
            _this._mainDiv.style.display = "block";
            _this._mainDiv.style.width = "100%";
            _this._mainDiv.style.height = "100%";
        }
        var ren = new ReactRenderer(_this._mainDiv, document, true, DataGridStylingDefaults);
        _this._reactRenderer = ren;
        var gridColumnMoveOptions = _this.i;
        gridColumnMoveOptions.provideRenderer(ren);
        if (props) {
            _this.initializeProperties();
        }
        return _this;
    }
    IgrGridColumnMoveOptions.prototype._getMainRef = function (ref) {
        this._elRef = ref;
    };
    IgrGridColumnMoveOptions.prototype.render = function () {
        var children = [];
        React.Children.forEach(this.props.children, function (ch) {
            children.push(ch);
        });
        var div = React.createElement("div", {
            className: "ig-grid-column-move-options igr-grid-column-move-options",
            ref: this._getMainRef,
            children: children
        });
        return div;
    };
    IgrGridColumnMoveOptions.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_1, _a;
        var mod = getModifiedProps(this.props, nextProps);
        try {
            for (var _b = tslib_1.__values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = mod[p];
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return true;
    };
    IgrGridColumnMoveOptions.prototype.initializeProperties = function () {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = this.props[p];
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
    };
    // supports angular themes or custom properties set in CSS
    IgrGridColumnMoveOptions.prototype.updateStyle = function () {
        this._styling(this._mainDiv, this);
    };
    IgrGridColumnMoveOptions.prototype.componentWillUnmount = function () {
        this.i.destroy();
        this._reactRenderer.destroy();
    };
    IgrGridColumnMoveOptions.prototype.componentDidMount = function () {
        this._elRef.appendChild(this._mainDiv);
        this.initializeContent();
    };
    IgrGridColumnMoveOptions.prototype.initializeContent = function () {
        this._styling(this._mainDiv, this);
        this.updateStyle();
    };
    IgrGridColumnMoveOptions.prototype.createImplementation = function () {
        return new GridColumnMoveOptions();
    };
    Object.defineProperty(IgrGridColumnMoveOptions.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridColumnMoveOptions.prototype, "moveLeftCaption", {
        get: function () {
            return this.i.b1;
        },
        set: function (v) {
            this.i.b1 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridColumnMoveOptions.prototype, "moveRightCaption", {
        get: function () {
            return this.i.b5;
        },
        set: function (v) {
            this.i.b5 = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridColumnMoveOptions;
}(IgrGridColumnOptionsSimpleSectionBase));
export { IgrGridColumnMoveOptions };
//# sourceMappingURL=igr-grid-column-move-options.js.map
